/*
 * Liefertermine für die Produktseite.
 *
 * Rechnet aus dem Bestellrhythmus des Hofs die konkreten Termine aus und
 * schreibt sie in die Seite: Bestellschluss mit Countdown, Versandtag,
 * Zustellfenster, Abholtag. Läuft im Browser, damit die Angaben auch dann
 * stimmen, wenn Shopify die Seite zwischenspeichert.
 *
 * Der Rhythmus kommt aus data-Attributen am Element, nicht aus dem Code:
 *   data-bestellschluss-tag    0 = Sonntag bis 6 = Samstag
 *   data-bestellschluss-stunde volle Stunde
 *   data-versand-versatz       Tage vom Bestellschluss bis zum Versand
 *   data-abholung-tag          Wochentag der Abholung
 *
 * So kann der Hof den Rhythmus im Theme-Editor ändern, ohne dass jemand
 * an den Code muss.
 */

(() => {
  const WOCHENTAGE = [
    'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag',
  ];
  const MONATE = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
  ];

  /** "26. August", mit Wochentag "Mittwoch, 26. August". */
  const datum = (d, mitWochentag) => {
    const kurz = `${d.getDate()}. ${MONATE[d.getMonth()]}`;
    return mitWochentag ? `${WOCHENTAGE[d.getDay()]}, ${kurz}` : kurz;
  };

  const plusTage = (d, n) => {
    const x = new Date(d.getTime());
    x.setDate(x.getDate() + n);
    return x;
  };

  /** Nächster Termin an diesem Wochentag zu dieser Stunde, frühestens morgen
   *  wenn der heutige schon vorbei ist. */
  const naechster = (jetzt, wochentag, stunde) => {
    const d = new Date(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate(), stunde, 0, 0, 0);
    d.setDate(d.getDate() + ((wochentag - d.getDay() + 7) % 7));
    if (d.getTime() <= jetzt.getTime()) d.setDate(d.getDate() + 7);
    return d;
  };

  /** "noch 18 Std. 6 Min." — ab einem Tag Restzeit gröber. */
  const restzeit = (ms) => {
    const tage = Math.floor(ms / 86400000);
    const std = Math.floor((ms % 86400000) / 3600000);
    const min = Math.floor((ms % 3600000) / 60000);
    if (tage > 0) return `noch ${tage} ${tage === 1 ? 'Tag' : 'Tage'} ${std} Std.`;
    if (std > 0) return `noch ${std} Std. ${min} Min.`;
    return `noch ${min} Min.`;
  };

  /** Jetzt-Zeitpunkt in der Zeitzone des Hofs, unabhängig davon, worauf
   *  das Gerät des Besuchers steht. Ohne das sieht jemand mit einem Gerät
   *  auf New Yorker Zeit den Bestellschluss um sechs Stunden verschoben und
   *  bestellt für eine Charge, die längst zu ist. */
  const jetztInBerlin = () => {
    const jetzt = new Date();
    try {
      const teile = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false,
      }).formatToParts(jetzt).reduce((o, p) => {
        if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10);
        return o;
      }, {});
      return new Date(teile.year, teile.month - 1, teile.day,
                      teile.hour % 24, teile.minute, teile.second);
    } catch (e) {
      // Ältere Browser ohne Zeitzonen-Unterstützung: Gerätezeit nehmen.
      return jetzt;
    }
  };

  const setze = (wurzel, feld, wert) => {
    wurzel.querySelectorAll(`[data-termin="${feld}"]`).forEach((e) => {
      e.textContent = wert;
    });
  };

  const rechne = (wurzel) => {
    const zahl = (name, standard) => {
      const v = parseInt(wurzel.dataset[name], 10);
      return Number.isNaN(v) ? standard : v;
    };
    const tag = zahl('bestellschlussTag', 3);        // Mittwoch
    const stunde = zahl('bestellschlussStunde', 15); // 15 Uhr
    const versatz = zahl('versandVersatz', 5);       // bis zum Montag
    const abholTag = zahl('abholungTag', 5);         // Freitag

    const jetzt = jetztInBerlin();
    const schluss = naechster(jetzt, tag, stunde);
    const versand = plusTage(schluss, versatz);
    const ab = plusTage(versand, 1);
    const bis = plusTage(versand, 2);
    /* Aus dem Bestellschluss gerechnet, nicht aus jetzt: sonst zeigt die
       Seite zwischen Mittwoch 15 Uhr und Freitag einen Abholtermin, der
       vor dem Bestellschluss liegt. */
    const abholung = naechster(schluss, abholTag, 17);

    const uhrzeit = `${String(stunde).padStart(2, '0')}:00 Uhr`;
    setze(wurzel, 'bestellschluss', `${datum(schluss, true)}, ${uhrzeit}`);
    setze(wurzel, 'countdown', `(${restzeit(schluss.getTime() - jetzt.getTime())})`);
    setze(wurzel, 'versand', datum(versand, true));
    setze(wurzel, 'zustellung', `${datum(ab, true)} bis ${datum(bis, false)}`);
    setze(wurzel, 'abholung', datum(abholung, true));
    setze(wurzel, 'ankunft', `Ab ${datum(ab, false)} bei euch`);
  };

  const start = () => {
    const wurzeln = document.querySelectorAll('[data-ws-termine]');
    if (!wurzeln.length) return;
    wurzeln.forEach(rechne);
    // Minütlich nachziehen, damit der Countdown mitläuft.
    setInterval(() => wurzeln.forEach(rechne), 60000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
